module.exports = __webpack_public_path__ + "img/1.ab36e0d2.jpg";